import React, { useState, useEffect, useRef } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import {
	TableCell,
	TableRow,
	Card,
	CardHeader,
	CardContent,
  Button,
  List,
  ListItem,
  Popper,
  colors
} from '@material-ui/core';
import { useQuery, useMutation } from '@apollo/client';
import _ from 'lodash';
import SearchBar from 'components/Search/SearchBar';
import { Link, useHistory, NavLink } from 'react-router-dom';
import Paper from '@material-ui/core/Paper';
import { VirtualizedTable } from 'components/Table/VirtualizedTable';
import {TableCellRenderer, Table} from 'react-virtualized';
import clsx from 'clsx';
import {UserFeedVars,UserFeedQuery,UserFeedData} from '@pvplevelup/core/dist/queries/user/userFeed'
import { Waypoint } from 'react-waypoint';
import { classImages } from 'utilities/ClassImages';
import { AocClasses } from '@pvplevelup/core/dist/interfaces/ICharacter';
import {UserSearchLookupData,UserSearchLookupQuery,UserSearchLookupVars} from '@pvplevelup/core/dist/queries/user/userLookup';

const useStyles = makeStyles((theme) => {
	return {
		title: {
			paddingTop: '8px'
    },
		cardCategoryWhite: {
			'&,& a,& a:hover,& a:focus': {
				color: 'rgba(255,255,255,.62)',
				margin: '0',
				fontSize: '14px',
				marginTop: '0',
				marginBottom: '0'
			},
			'& a,& a:hover,& a:focus': {
				color: '#FFFFFF'
			}
		},
		cardTitleWhite: {
			color: '#FFFFFF',
			marginTop: '0px',
			minHeight: 'auto',
			fontWeight: 'bold',
			fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
			marginBottom: '3px',
			textDecoration: 'none',
			'& small': {
				color: '#777',
				fontSize: '65%',
				fontWeight: '400',
				lineHeight: '1'
			}
		},
		cardHeader: {
			padding: '0.75rem 1.25rem',
			marginBottom: '0',
			borderBottom: 'none',
			background: theme.palette.primary.main,
			zIndex: 3
    },
    buttonProgress: {
      color: theme.palette.primary.main,
      position: 'absolute',
      top: '50%',
      left: '50%',
      marginTop: -12,
      marginLeft: -12,
    },
    classGrid: {
      display: "grid",
      gridTemplateColumns: "repeat(13, 1fr)",
      gap: '1em'
    },
    classIcon: {
      width:'3em',
      cursor:'pointer'
    },
    userContainer: {
      marginTop: '1em',
      minWidth:'20vw',
      height:'25em',
      overflow:'auto',
    },
    link: {
      textDecoration: "none",
      color: "#6cbbff",
      "&:hover,&:focus": {
        color: "#FFF"
      }
    }
	};
});

interface Props {}

export const UserList: React.FC<Props> = (props) => {
	const history = useHistory();
	const classes = useStyles();

  const [ name, setName ] = useState('');
  const [ showUserSearch, setShowUserSearch ] = useState(false);
  const [ user, setUser ] = useState('');
	const [ typing, setTyping ] = useState(false);
  const [ typingTimeout, setTypingTimeout ] = useState<NodeJS.Timeout | undefined>();
  const [ useAssassin, setUseAssassin] = useState(false);
  const [ useBarbarian, setUseBarbarian] = useState(false);
  const [ useRanger, setUseRanger] = useState(false);
  const [ usePriestofMitra, setUsePriestofMitra] = useState(false);
  const [ useBearshaman, setUseBearshaman] = useState(false);
  const [ useTempestofSet, setUseTempestofSet] = useState(false);
  const [ useGuardian, setUseGuardian] = useState(false);
  const [ useConqueror, setUseConqueror] = useState(false);
  const [ useDarkTemplar, setUseDarkTemplar] = useState(false);
  const [ useDemonologist, setUseDemonologist] = useState(false);
  const [ useHeraldofXotli, setUseHeraldofXotli] = useState(false);
  const [ useNecromancer, setUseNecromancer] = useState(false);
  const [ reseting, setReseting ] = useState(false);
  const [ shouldRefetch, setShouldRefetch ] = useState(false);
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const scrollableAncestor = useRef(null);
  const [ignoreNextPrevious, setIgnoreNextPrevious] = useState(false);
  const gridRef = useRef<Table>(null);


  const [newLength, setNewLength] = useState<number | null>(null);
  const [nextCursor, setNextCursor] = useState<string | undefined>("");
  const [hasNextCursor, setHasNextCursor] = useState<boolean | undefined>(false);
  const [previousCursor, setPreviousCursor] = useState<string | undefined>("");
  const [hasPreviousCursor, setHasPreviousCursor] = useState<boolean | undefined>(false);
  const [isInitial, setIsInitial] = useState(true);
  const [scrollToIndex, setScrollToIndex] = useState<number | undefined>(undefined);
  const [startingIndex, setStartingIndex] = useState(0);

	const { refetch, data, loading, fetchMore } = useQuery<UserFeedData, UserFeedVars>(UserFeedQuery, {
    variables: {search:"",next:"",previous:""},
    fetchPolicy:'network-only',
    nextFetchPolicy:'cache-and-network'
    /*onCompleted: (data) => {
      if(data.userFeed){
        setNextCursor(data.userFeed.next);
        setHasNextCursor(data.userFeed.hasNext);
        setPreviousCursor(data.userFeed.previous);
        setHasPreviousCursor(data.userFeed.hasPrevious);
      }
    }*/
  });
	

	const onChangeName = (newName: string) => {
		if (typingTimeout) clearTimeout(typingTimeout);

		setName(newName);
		setTyping(true);
		setTypingTimeout(
			setTimeout(() => {
				refetch({previous:"",next:"",search:newName});
				setTyping(false);
			}, 600)
		);
  };


  const fetchMoreRecords = async (next: boolean = true)=>{
    if(((next && (isInitial || hasNextCursor)) || (!next && (hasPreviousCursor))) && !loading){
      
      let variables:UserFeedVars = {search:name}
      if(next){
        variables.next = isInitial ? data?.userFeed.next : nextCursor;
      }else{
        variables.previous = previousCursor;
      }
        
      let fetchMoreResult = await fetchMore({
        variables:variables,
        updateQuery: (prev, {fetchMoreResult}) => {
          if (!fetchMoreResult) return prev;
          let users = [...prev?.userFeed?.users || [], ...fetchMoreResult.userFeed.users];
          users = _.uniqBy(users,(user)=>user._id);

          if(next)
            setScrollToIndex(undefined);
            
            
          return Object.assign({}, prev, {
            userFeed:{
              next: fetchMoreResult.userFeed.next,
              previous: fetchMoreResult.userFeed.previous,
              hasNext: fetchMoreResult.userFeed.hasNext,
              hasPrevious: fetchMoreResult.userFeed.hasPrevious,
              users: users,
              __typename: fetchMoreResult.userFeed.__typename
            }
          });
        }
      })

      setIsInitial(false);

      if(fetchMoreResult.data){
        if(!next){
          setNewLength(fetchMoreResult.data.userFeed.users.length + (data?.userFeed?.users?.length || 0));
          setPreviousCursor(fetchMoreResult.data.userFeed.previous);
          setHasPreviousCursor(fetchMoreResult.data.userFeed.hasPrevious);
        }else{
          setNewLength(0);
          setNextCursor(fetchMoreResult.data.userFeed.next);
          setHasNextCursor(fetchMoreResult.data.userFeed.hasNext)
        }
      }
    }
  }

  useEffect(()=>{
    if(data?.userFeed.users.length == newLength && !isInitial){
      let scrollTo = 30 + startingIndex;
      setScrollToIndex(scrollTo);
    }
  },[data?.userFeed.users.length, newLength])

  return (
		<Grid container spacing={1} className="content-container">
      <Grid item xs={12}>
				<SearchBar onChange={onChangeName} onFocus={(e)=>{
          setAnchorEl(e.target);
        }} onBlur={(e)=>{
          setTimeout(()=>{  
            setAnchorEl(null);
          },500)
        }} value={name} placeholder={"Search the user..."} />
			</Grid>
			<Grid item xs={12}>
				<Card>
					<CardHeader
						component={() => (
							<div className={classes.cardHeader}>
								<h4 className={classes.cardTitleWhite}>User {(data?.userFeed?.users?.length || 0) > 0 ? `(${data?.userFeed.users.length})` : ""}</h4>
								<p className={classes.cardCategoryWhite}>Matchmaking user</p>
							</div>
						)}
					/>
          
					<CardContent>
            <div style={{ height: 'calc(97vh - 276px)', width: '100%' }}>
              {hasPreviousCursor && 
                <Button disabled={loading} variant="contained" fullWidth onClick={()=>{fetchMoreRecords(false)}} color="primary">Load Previous</Button>
              }
              <VirtualizedTable
                reference={gridRef}
                rowCount={data?.userFeed?.users?.length || 0}
                rowGetter={({ index }) => data?.userFeed?.users[index]}
                scrollToIndex={scrollToIndex}
                onRowsRendered={({startIndex})=>{
                  setStartingIndex(startIndex);
                }}
                customCellRenderer={({columnIndex,rowIndex,cellData,rowData})=>{
                  return (<React.Fragment>
                    {columnIndex == 0 ? 
                      <NavLink to={`/users/${rowData._id}`} className={classes.link}>{cellData}</NavLink>
                    : columnIndex == 1 ?
                      <img className="friend-player-icon" src={cellData} style={{borderRadius:'50%'}} />
                    : 
                      cellData
                    }
                    {(columnIndex == 0 && rowIndex == (data?.userFeed?.users?.length || 0) - 3) &&
                      <Waypoint
                        onEnter={async ()=>{
                          await fetchMoreRecords();
                        }}
                      />
                    }
                  </React.Fragment>)
                }}
                columns={[
                  {
                    width: 150,
                    label: 'Name',
                    dataKey: 'displayname'
                  },
                  {
                    width: 80,
                    label: 'Avatar',
                    dataKey: 'avatar',
                  }
                ]}
              />
            </div>
					</CardContent>
				</Card>
			</Grid>
		</Grid>
	);
};
